import { Component, OnInit } from '@angular/core';
import { Globals } from '../../globals';
import { GridOptions } from "ag-grid/main";
import { ActivatedRoute, Router } from "@angular/router";
import { RatersService } from 'app/services/rater/RatersService';

@Component({
  selector: 'app-rater-assessments',
  templateUrl: './rater-assessments.component.html',
  styleUrls: ['./rater-assessments.component.scss']
})
export class RaterAssessmentsComponent implements OnInit {
    assessments: any[] = [];
    dataHeaders: any[];
    gridOptions: GridOptions;
    gridApi;
    gridColumnApi;
    overlayNoRowsTemplate;
    rowSelection;

    height: number;
    count: number;

    canTakeAssessment: boolean = false;

    constructor(
        private _RatersService: RatersService,
        private _Globals: Globals,
        private _router: Router) {
        this.overlayNoRowsTemplate = "<span>No row to show</span>";
        this.rowSelection = "single";
    }

    ngOnInit() {
        this.gridOptions = <GridOptions>{};
        this.gridOptions.rowHeight = 45;
        this.gridOptions.headerHeight = 40;

        this.dataHeaders = this.createHeaders();

		//service call
        this.getRaterAssessments();
    }

    getRaterAssessments() {
        this._RatersService.getAssessments().subscribe((data: any) => { 
            console.log('response_GetAssessments', data);

            if (this._Globals.validationToken(data.result.Result)) {
                let _data = JSON.parse(data.result.Data);
                console.log('_data', _data);
                this.assessments = _data;
            }
        });
    }

    onRowSelected(event) {
        console.log("onRowSelected", event);
    }

    onSelectionChanged(event) {
        console.log("onSelectionChanged ", event);
        var rowCount = event.api.getSelectedNodes().length;
        console.log("selection changed, ", rowCount + " rows selected");

        if (rowCount == 1) {
            this.canTakeAssessment = true;
        } else {
            this.canTakeAssessment = false;
        }
    }

    getSelected() {
        let selected = this.getSelectedRows();
        console.log('selected', selected);
    }

    getSelectedRows(): any {
        return this.gridApi.getSelectedRows();
    }

    gridSize(count: number) {
        this.count = count;
        console.log('count', this.count);
        this.height = (this.count + 1) * 43;
    }

    sizeToFit() {
        this.gridApi.sizeColumnsToFit();
        $('.ag-body-viewport').css('overflow', 'overlay');
    }

    onGridReady(params) {
        this.gridApi = params.api;
        this.sizeToFit();
        setTimeout(() => {
            $(".ag-floating-filter-input").attr("placeholder", "Filter");
        }, 100);
    }

    createHeaders() {
        let columnDefs = new Array();

        //let actionsHeader = {
        //    headerName: 'Actions',
        //    field: '',
        //    minWidth: 150,
        //    width: 150,
        //    suppressSizeToFit: true,
        //    suppressSorting: true,
        //    suppressMenu: true,
        //    cellRenderer: function (params) {
 
        //        let content = '';
        //        content += '<i id="takeAssessment" class="material-icons custom-icons rotate180">keyboard_backspace</i>';
        //        //content += '<a id="takeAssessment" class="link" style="vertical-align:middle; padding-right:7px;">Begin assessment</a>'; 
 
        //         if(params.data.Is360){
        //             content += '<i id="assignRaters" class="material-icons custom-icons">group</i>';
        //         }
        //        return '<span style="margin-top: 4px !important;position: absolute;">' + content + '</span>';
        //    }
        // };
        // columnDefs.push(actionsHeader);

        let ownerHeader = {
            headerName: 'Owner',
            field: 'Owner',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: false,
            // headerCheckboxSelection: true,
            // headerCheckboxSelectionFilteredOnly: true,
            // checkboxSelection: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(ownerHeader);

        let relationshipHeader = {
            headerName: 'Relationship',
            field: 'Relationship',
            minWidth: 200,
            width: 200,
            suppressSizeToFit: true,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(relationshipHeader);

        let assessmentNameHeader = {
            headerName: 'AssessmentName',
            field: 'AssessmentName',
            minWidth: 150,
            width: 150,
            suppressSizeToFit: false,
            cellRenderer: function (params) {
                return params.value;
            }
        };
        columnDefs.push(assessmentNameHeader);

        return columnDefs;
    }
	
    public onRowClicked(e) {
        console.log(e);
        if (e.event.target !== undefined) {
            let data = e.data;

            this.takeAssessment(data['AssessmentId'], data['AssignmentId'], data['AssessmentName'], data['Language'], data['Owner']);

            //switch (e.event.target.id) {
            //    case 'takeAssessment':
            //        {
            //            //this.editClient(data['id'], data['name'], data['notes'], data['userName'], data['createdOn']);
            //            this.takeAssessment(data['AssignmentId']);
            //            break;
            //        }

                
            //}
        }
    }

    takeAssessment(assessmentId: number, assignmentId: number, assessmentName: string, assessmentLanguage: string, fullName: string) {
        const data = this.getSelectedRows();
        console.log(data);

        this._router.navigate(
            ['/app/assigned_assessment', 'rater', assessmentId, assignmentId, assessmentName, assessmentLanguage, fullName],
            {state: {showBanner: false }});

    }

}
